export default "__VITE_ASSET__40e093e1__"